<template>
  <div id="contenedor-contratista-contratos-minutas">
    <div class="d-flex justify-space-between align-start flex-md-nowrap flex-wrap">
      <div id="contenedor-listado-minutas" class="mr-0 mr-md-3 flex-grow-1 flex-shrink-0">
        <v-card flat class="rounded-lg">
          <v-toolbar flat>
            <v-toolbar-title>
              Listado de Minutas
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              fab
              small
              text
              @click="refreshListadoMinutas">
              <v-icon>
                mdi-refresh
              </v-icon>
            </v-btn>
            <v-btn
              rounded
              class="text-capitalize mr-2"
              text
              @click="mostrarConfigurarMinutas = true">
              Asuntos
            </v-btn>
            <v-btn
              color="primary"
              rounded
              small
              class="text-capitalize"
              @click="mostrarAgregarMinuta = true">
              <v-icon left small>
                mdi-plus
              </v-icon>
              Nueva
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-skeleton-loader v-if="$apollo.queries.contratoMinutas.loading"
              type="table-thead, table-tbody">
            </v-skeleton-loader>
            <listado v-else :listado="getContratoMinutas"></listado>
          </v-card-text>
        </v-card>
      </div>
      <div id="contenedor-asuntos-pedientes" class="mt-4 mt-md-0">
        <v-card flat outlined class="rounded-lg">
          <v-toolbar dense flat>
            <v-toolbar-title>
              Acuerdos pendientes
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                  <v-btn small fab text v-bind="attrs" v-on="on" @click="verTodosVencidos()">
                  <v-icon>
                      mdi-magnify-plus-outline
                  </v-icon>
                  </v-btn>
              </template>
              <span>
                  Ver todos Acuerdos vencidos
              </span>
            </v-tooltip>
          </v-toolbar>
          <v-divider class="mx-2"></v-divider>
          <v-card-text>
            <v-alert
              v-if="!getContratoMinutasAcuerdosVencidos.length"
              type="info"
              dense>
              No hay acuerdos pendientes
            </v-alert>
            <Acuerdos v-else :listado="getContratoMinutasAcuerdosVencidos"></Acuerdos>
          </v-card-text>
        </v-card>
      </div>
    </div><!-- Ventana Agregar Minuta -->
      <v-dialog
        v-if="mostrarAgregarMinuta"
        v-model="mostrarAgregarMinuta"
        width="600"
        persistent>
        <NuevaMinuta
        v-on:cerrar="mostrarAgregarMinuta=!mostrarAgregarMinuta"
        :idContrato="idContrato"/>
      </v-dialog>
      <!-- Ventana Listado Acuerdos -->
      <v-dialog
        v-if="mostrarAcuerdosVencidos"
        v-model="mostrarAcuerdosVencidos"
        width="650"
        persistent>
        <ListadoAcuerdosVencidos
        v-on:cerrar="mostrarAcuerdosVencidos=!mostrarAcuerdosVencidos"
        />
      </v-dialog>
      <v-dialog
        v-model="mostrarMinutasAsuntos"
        scrollable>
        <v-card v-if="estaMinuta">
          <v-card-title>
            Asuntos de la minuta {{ estaMinuta.numero }}
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon @click="cerrarMinutasAsuntos()">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider class="mx-2"></v-divider>
          <v-card-text>
            <Asuntos ref="minutaAsuntos" :idContrato="this.idContrato" :idMinuta="estaMinuta.id">
            </Asuntos>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <custom-button
              @click="cerrarMinutasAsuntos()"
              tipo="formCancelar" label="Cancelar" class="mr-3">
            </custom-button>
            <custom-button
              @click="actualizarMinutaAsuntos()"
              tipo="formAceptar"
              label="Guardar"
            >
            </custom-button>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
      v-model="mostrarConfigurarMinutas"
      scrollable
      persistent
      width="70%">
      <v-card>
        <v-card-title>
          Asuntos
          <v-spacer></v-spacer>
          <v-btn icon @click="mostrarConfigurarMinutas = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mx-2"></v-divider>
        <v-card-text>
          <ConfiguracionMinutas
          :idContrato="idContrato" />
        </v-card-text>
      </v-card>
      </v-dialog>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';
import CONTRATO_MINUTAS from '@/graphql/querys/administracion/minutas/contratoMinutas.gql';
import CONTRATOS_MINUTAS_ACUERDOS_VENCIDOS from '@/graphql/querys/administracion/minutas/contratoMinutasAcuerdosVencidos.gql';
import CustomButton from '@/components/buttons/Button.vue';
import NuevaMinuta from '@/components/administracion/minutas/minuta/Nueva.vue';
import ListadoAcuerdosVencidos from '@/components/administracion/minutas/acuerdos/listadoVencidos.vue';
import Listado from './listado/Desktop.vue';
import Acuerdos from './listado/Acuerdos.vue';
import Asuntos from './listado/Asuntos.vue';
import ConfiguracionMinutas from './configuracion/Main.vue';

export default {
  name: 'ContratistaContratosMainMinuta',
  components: {
    CustomButton,
    Listado,
    Acuerdos,
    Asuntos,
    NuevaMinuta,
    ListadoAcuerdosVencidos,
    ConfiguracionMinutas,
  },
  data() {
    return {
      mostrarAgregarMinuta: false,
      mostrarAcuerdosVencidos: false,
      mostrarMinutasAsuntos: false,
      mostrarConfigurarMinutas: false,
      idContrato: this.$route.params.idContrato,
      estaMinuta: null,
    };
  },
  mounted() {
    eventBus.$on('ver-minuta-asuntos', (minuta) => {
      this.mostrarMinutasAsuntos = true;
      this.estaMinuta = minuta;
    });
    eventBus.$on('acuerdos-vencidos-actualizar', async () => {
      await this.actualizarMinutaAsuntosVencidos();
    });
  },
  apollo: {
    contratoMinutas: {
      query: CONTRATO_MINUTAS,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
    contratoMinutasAcuerdosVencidos: {
      query: CONTRATOS_MINUTAS_ACUERDOS_VENCIDOS,
      variables() {
        return {
          numeroRegistros: 10,
          pagina: 1,
        };
      },
    },
  },
  methods: {
    async refreshListadoMinutas() {
      await this.$apollo.queries.contratoMinutas.refetch({
        idContrato: this.idContrato,
      });
    },
    async actualizarMinutaAsuntosVencidos() {
      await this.$apollo.queries.contratoMinutasAcuerdosVencidos.refetch({
        numeroRegistros: 10,
        pagina: 1,
      });

      await this.refreshListadoMinutas();
    },
    actualizarMinutaAsuntos() {
      this.$refs.minutaAsuntos.actualizarMinutaAsuntos();
      this.cerrarMinutasAsuntos();
    },
    cerrarMinutasAsuntos() {
      this.mostrarMinutasAsuntos = false;
      this.estaMinuta = null;
    },
    verTodosVencidos() {
      this.mostrarAcuerdosVencidos = true;
    },
  },
  computed: {
    getContratoMinutas() {
      if (!this.contratoMinutas) return [];
      return this.contratoMinutas
        .slice()
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
    getContratoMinutasAcuerdosVencidos() {
      if (!this.contratoMinutasAcuerdosVencidos) return [];
      return this.contratoMinutasAcuerdosVencidos
        .map((acuerdo) => ({
          id: acuerdo.id,
          nombre: acuerdo.descripcion,
          fecha: acuerdo.fechaLimite,
          fechaHoraCumplimiento: acuerdo.fechaHoraCumplimiento,
          fechaLimite: acuerdo.fechaLimite,
          numero: acuerdo.numero,
          descripcion: acuerdo.descripcion,
          nombreReponsable: acuerdo.nombreReponsable,
          puestoResponsable: acuerdo.puestoResponsable,
        }));
    },
  },
};
</script>

<style lang="scss">
#contenedor-listado-minutas {
  width: 69% !important;
}

#contenedor-asuntos-pedientes {
  width: 28% !important;
}

@media screen and (max-width: 768px) {
  #contenedor-listado-minutas, #contenedor-asuntos-pedientes {
    width: 100% !important;
  }
}

</style>
